<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Rania Namer Eitah is a writer of prose stories, novels, and poetry. She was born in Syria, in 1981. She holds a Bachelor of Arts degree in English literature, from Damascus University. She also holds a postgraduate educational certificate from Damascus University, in English language, and is also a human development trainer.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6a3ac523